export class AdSplashEnum {
    static SEEN = "1";
}

export default AdSplashEnum;
